export const space = (token) => `var(--space-${token})`;
export const radius = (token) => `var(--radius-${token})`;
//# sourceMappingURL=tokens.js.map